import { ColorValue, NativeModules, processColor } from 'react-native';

import { isWeb } from './constants-platform-specific';

type RootViewBackgroundNativeModule = {
    setBackgroundColor: (color: number) => void;
};

const RootViewBackgroundModule: RootViewBackgroundNativeModule | undefined = NativeModules.RootViewBackgroundModule;

/**
 * Sets the color of the native view behind all screens (iOS root view, Android window).
 * It starts purple for the launch screen. It shows during native stack transitions.
 */
export const setRootViewBackgroundColor = (color: ColorValue) => {
    if (isWeb) {
        return;
    }

    const processedColor = processColor(color);
    if (typeof processedColor !== 'number') {
        return;
    }

    RootViewBackgroundModule?.setBackgroundColor(processedColor);
};
